import { Component, OnInit } from '@angular/core';
import { ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'global-abn-config',
  standalone: false,
  templateUrl: './global-abn-config.component.html'
})
export class GlobalAbnConfigComponent implements OnInit {
  tableConfig: ABCisTableModel;
  constructor() { }

  ngOnInit() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'global-abn',
        approxamateRowCount: 1000,
        anyParams: true
      },
      addFormConfig: {
        header: 'Add Global Abn'
      },
      colConfig: [
        { field: 'globalAbnId', header: 'Global Abn Id', type: ColumnType.String, isReadonly: true, isPrimary: true, notInForm: true  },
        { field: 'abn', header: 'ABN', type: ColumnType.String, isReadonly: true },
        { field: 'searchRegex', header: 'Regex', type: ColumnType.String },
      ],
      isConfigurable: true
    };
  }
}
